import type { AutoDateHistogramAgg } from '../types/query'

/**
 * Adaptive date histogram. The chart uses this so a 5-minute window
 * doesn't collapse to a single bar (the v1 bug).
 *
 * @param buckets Maximum desired buckets (defaults to 50)
 */
export function autoDateHistogramAgg(
	field: string,
	buckets = 50,
): AutoDateHistogramAgg {
	return {
		auto_date_histogram: {
			field,
			buckets,
			format: 'date_time',
		},
	}
}
